<template>
<div class="content">
  <nav>
    <router-link class="active" to="/qrcode">网址二维码生成器</router-link>
    <router-link to="/shortlink">短链接生成器</router-link>
  </nav>
  <h1>网址二维码生成器</h1>
  <div class="form">
    <input v-model.trim="longUrl" placeholder="http://" autofocus><button @click="generatorQrcode">生成二维码</button>
  </div>
  <div class="output">
    <div id="qrcode"><img :src="qrCodeUrl"><span></span></div>
    <!-- <a v-if="qrCodeUrl" class="button" :href="qrCodeUrl + '.png'" download>下载二维码</a> -->
    <a v-if="qrCodeUrl" class="button" :href="qrCodeUrl" target="_blank">下载二维码</a>
  </div>
</div>
</template>

<script>
// import ajaks from 'ajaks';
import axios from 'axios'

export default {
  name: "qrcode",
  data() {
    return {
      longUrl: '',
      qrCodeUrl: '',
    }
  },
  methods: {
    generatorQrcode: function () {
      let longUrl = this.longUrl;
      document.querySelector('#qrcode span').innerHTML = '';
      this.qrCodeUrl = '';
      // ajaks.post('/url/shortenQr', {longUrl}).then(data => {
      //   if (data.code && data.code === 400) {
      //     document.querySelector('#qrcode span').innerHTML = '无效的链接';
      //   } else {
      //     this.qrCodeUrl = data.qrCodeUrl;
      //   }
      // });
      const params = new URLSearchParams()
      params.append('longUrl', longUrl)
      params.append('noLogo', true)
      axios.post('/toolbox/link/api/url/shortenQr', params).then(({data}) => {
        if (data.code && data.code === 400) {
          document.querySelector('#qrcode span').innerHTML = '无效的链接';
        } else {
          this.qrCodeUrl = data.qrCodeUrl;
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/tool.scss';
</style>
